import { RouteObject } from "react-router";

import { CurrentClientName } from "@components/Texts";

import { ExtensionInstallationGuard } from "@components/RouteGuards/ExtensionInstallationGuard/ExtensionInstallationGuard";

import { routes } from "@pages/routes";

import { ApplicationUsageByUsers } from "./ApplicationUsageByUsers/ApplicationUsageByUsers.page";
import { Client } from "./Client/Client.page";
import { ClientDashboard } from "./ClientDashboard/ClientDashboard.page";
import { ClientNotifications } from "./ClientNotifications/ClientNotifications.page";
import { Clients } from "./Clients/Clients.page";
import { ColumnSettings } from "./ColumnSettings/ColumnSettings.page";
import { CreateClient } from "./CreateClient/CreateClient.page";
import { ExtensionInstallation } from "./ExtensionInstallation/ExtensionInstallation.page";

export const clientRoutes = [
  {
    path: routes.portal.clients.$path(),
    Component: Clients,
    children: [
      {
        path: routes.portal.clients.columnSettings.$path(),
        Component: ColumnSettings,
      },
    ],
  },
  {
    path: routes.portal.clients.create.$path(),
    Component: CreateClient,
    handle: {
      breadcrumb: {
        title: "Create",
      },
    },
  },
  {
    path: routes.portal.clients.client.$path(),
    Component: ExtensionInstallationGuard,
    children: [
      {
        path: routes.portal.clients.client.record.$path(),
        Component: Client,
        handle: {
          breadcrumb: {
            reset: true,
            left: <CurrentClientName />,
            title: "Record",
          },
        },
      },
      {
        path: routes.portal.clients.client.dashboard.$path(),
        Component: ClientDashboard,
        handle: {
          breadcrumb: {
            reset: true,
            left: <CurrentClientName />,
            title: "Dashboard",
          },
        },
        children: [
          {
            path: routes.portal.clients.client.dashboard.applicationUsageByUsers.$path(),
            Component: ApplicationUsageByUsers,
          },
          {
            path: routes.portal.clients.client.dashboard.extensionInstallation.$path(),
            Component: ExtensionInstallation,
          },
        ],
      },
      {
        path: routes.portal.clients.client.notifications.$path(),
        Component: ClientNotifications,
        handle: {
          breadcrumb: {
            reset: true,
            left: <CurrentClientName />,
            title: "Notifications",
          },
        },
      },
    ],
  }
] satisfies RouteObject[];
